module.exports = __webpack_public_path__ + "img/thumbnail_cityboundaries_labels.be75906b.jpg";